import React, {useEffect, useMemo, useRef, useState} from 'react'
import {Button, Col, Form, Image, Row} from "react-bootstrap";
import Select from "react-select";
import {monthsArray} from "../../../stores/StratProject/StrategyStore";
import style from "../../strategyProject/tabs/TabResults/TabResults.module.less";
import Calendar from "react-calendar";
import Required from "../../Required";
import {useOutsideBounder} from "../../../hooks/useOutsideClick";
import FileInput from "../../UI/upload/FileInput";
import pdfIcon from "../../../../img/icons/pdf.svg"
import useAPI from "../../../hooks/useAPI";
import ConfirmModal from "../../common/ConfirmModal";
import TooltippedElement from "../../common/TooltippedElement";
import NewsEditImageSelect from '../../News/Edit/ImageSelect';
import RenderingImage from '../../common/RenderingImage';
import { useParams } from 'react-router-dom';

export default function ReportMilestoneForm({milestone, setMilestone, readonly, trls, startValidation, validated, setFiles, newFiles, image, setImage}){
    const dateRef = useRef(null);
    const formRef = useRef(null);
    const resultInputRef = useRef(null);
    const [loadingFile, setLoadingFile] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [fileToDelete, setFileToDelete] = useState(null)
    const {projId, milestoneId} = useParams()

    const api = useAPI();
    useOutsideBounder(dateRef)

    const trlsOptions = useMemo(() => trls.map((value) => ({label: `${value.id} - ${value.descr}`, value: value.id})), [trls])

    useEffect(() => {
        if (validated && formRef.current){
            if (!formRef.current.checkValidity()){
                const invalidInput = formRef.current.querySelector(':invalid')
                invalidInput.focus()
            }
            else if (milestone.result.length > 1500){
                resultInputRef.current.focus()
            }
        }
    }, [startValidation, validated])

    const downloadFile = async (id, fileName) => {
        setLoadingFile(true)
        await api.download(`/minioFiles/download/${id}`, fileName)
        setLoadingFile(false)
    }

    const deleteFile = async (id) => {
        setMilestone({...milestone, files: [...milestone.files.filter((value) => value.id !== id)]})
        await api.del(`/minioFiles/remove/${id}`)
    }

    return (
        <Form noValidate validated={validated} className='d-flex flex-column gap-4' ref={formRef}>
            <Form.Group>
                <Form.Label style={styledLabel}>Название вехи</Form.Label>
                <Form.Control defaultValue={milestone.name} readOnly/>
            </Form.Group>
            <Form.Group>
                <Form.Label style={styledLabel}>УГТ (план)</Form.Label>
                <Form.Control value={milestone.trlId ? `${milestone.trlId} - ${trls.find((trl) => trl.id === milestone.trlId)?.descr}` : '-'} readOnly/>
            </Form.Group>
            <Form.Group>
                <Form.Label style={styledLabel}>
                    УГТ (факт)
                    <TooltippedElement iconSize="16px" tooltip="Уровень готовности технологии" />
                </Form.Label>
                <Select
                    styles={{
                        control: (base) => ({...base, backgroundColor: readonly ? '#e9ecef' : 'fff', opacity: 1, border: '1px solid rgb(206, 212, 218)'}),
                        singleValue: (base) => ({...base, color: '#212529'}),
                }}
                    placeholder='Выберите значение из списка'
                    options={[{label: 'Не указано', value: null}, ...trlsOptions]}
                    value={trlsOptions.find((opt) => opt.value === milestone.trlFactId) || {label: 'Не указано', value: null}}
                    onChange={(event) => setMilestone({...milestone, trlFactId: event.value})}
                    isDisabled={readonly}
                />
            </Form.Group>
            <Row>
                <Col xs={5}>
                    <Form.Group>
                        <Form.Label style={styledLabel}>Дата выполнения (план)</Form.Label>
                        <Form.Control value={`${monthsArray[milestone.monthPlan - 1]} ${milestone.yearPlan}`} readOnly/>
                    </Form.Group>
                </Col>
                <Col xs={7}>
                    <Form.Group>
                        <Form.Label style={styledLabel}>Ответственный</Form.Label>
                        <Form.Control defaultValue={milestone.personsInCharge && milestone.personsInCharge[0] ?
                            `${milestone.personsInCharge[0]?.displayName} (${milestone.personsInCharge[0]?.post})` :
                            null} readOnly/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={5}>
                    <Form.Group>
                        <Form.Label>Дата выполнения (факт) <Required className="ml-2" /></Form.Label>
                        <Form.Control
                            className={style.dataOverride}
                            required
                            onFocus={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                dateRef.current.classList.add(style.get);
                            }}
                            onBlur={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            value={milestone.monthFact ? `${monthsArray[milestone.monthFact - 1]} ${milestone.yearFact}` : ''}
                            placeholder="Введите дату"
                            readOnly
                            disabled={readonly}
                        />
                        <Calendar
                            className={`${style.calendar}`}
                            inputRef={dateRef}
                            onChange={(value) => setMilestone({...milestone, monthFact: value.getMonth() + 1, yearFact: value.getFullYear()})}
                            maxDetail="year"
                            locale='ru-RU'
                        />
                        {validated && !(milestone.monthFact && milestone.yearFact) && <p style={styledAlert}>
                            Поле обязательно к заполнению.
                        </p>}
                    </Form.Group>
                </Col>
                <Col xs={7}/>
            </Row>
            <Form.Group>
                <Form.Label className='d-flex' style={styledLabel}>
                    <p>Достижение вехи <Required/></p>
                    <p className='ms-auto'>{milestone.result?.length || 0}/1500</p>
                </Form.Label>
                <Form.Control
                    style={{height: 120}}
                    as="textarea"
                    placeholder='Макс. 1500 символов'
                    value={milestone.result}
                    required
                    onChange={(event) => setMilestone({...milestone, result: event.target.value})}
                    readOnly={readonly}
                    ref={resultInputRef}
                />
                <Form.Control.Feedback type="invalid">
                    Поле обязательно к заполнению.
                </Form.Control.Feedback>
                {validated && milestone.result && milestone.result.replaceAll(' ', '').length > 1500 && <p className='mt-2' style={styledAlert}>
                    Длина текста должна быть не более 1500 символов
                </p>}
            </Form.Group>
            <Form.Group>
                {(!readonly || milestone.files && milestone.files?.length > 0) && <Form.Label style={styledLabel}>Документы</Form.Label>}
                {!readonly && <FileInput
                    message='Файл должен быть формата .pdf и содержать подпись руководителя проекта'
                    style={{height: 120}}
                    onFileChange={(files) => setFiles(files)}
										customState
										fileList={newFiles}
										validExtensions={['pdf']}
                />}
                <ul className='d-flex flex-column' style={{gap: 10, marginTop: 10}}>
                    {milestone.files?.map((file) => <li className='d-flex ps-1'>
                        <Image src={pdfIcon} style={{width: 24, marginRight: 4}}/>
                        <p
                            className='text-primary'
                            onClick={() => !loadingFile ? downloadFile(file.id, file.name) : null}
                            style={{cursor: "pointer"}}
                        >{file.name}</p>
                        {!readonly && <Button
                            variant="light"
                            className="ms-auto btn-close"
                            size="sm"
                            onClick={() => {
                                setShowModal(true)
                                setFileToDelete(file)
                            }}
                        />}
                    </li>)}
                </ul>
            </Form.Group>
            <Form.Group>
              <Form.Check
                checked={milestone.publishInMedia}
                onClick={() => setMilestone((prevState) => ({...prevState, publishInMedia: !prevState.publishInMedia}))}
                label={'Опубликовать в СМИ (Информация о достижении вехи будет отправлена на согласование руководителю стратегического проекта и передана в Медиацентр УрФУ для публикации в средствах массовой информации)'}
               /> 
            </Form.Group>
            {milestone.publishInMedia && <Form.Group>
                    <Form.Label>Заголовок новости</Form.Label>
                    <Form.Control
                        type='text'
                        placeholder='Введенный заголовок будет опубликован к новости в СМИ'
                        value={milestone.newsHeaderDraft}
                        onChange={(event) => setMilestone({...milestone, newsHeaderDraft: event.target.value})}
                    />
                </Form.Group>}
            <Form.Group className='d-flex flex-column align-items-start'>
                <Form.Label style={styledLabel}>Изображение <TooltippedElement tooltip='Прикрепленное изображение будет опубликовано к новости в СМИ (в случае, если веха отмечена для публикации)'/></Form.Label>
                {milestone.imageFileId ?
                        <div className='d-flex flex-column gap-3 align-items-start' style={{width: 'min-content'}}>
                            <RenderingImage style={{width: 300, height: 'auto'}} url={`/minioFiles/download/${milestone.imageFileId}`}/>
                            <Button onClick={() => {
                                    api.del(`/projs/${projId}/milestones/${milestoneId}/image`)
                                    setMilestone({...milestone, imageFileId: null})
                                    setImage(null)
                                }}>Удалить изображение</Button>
                        </div>
                         :
                        <NewsEditImageSelect
                            file={image}
                            setFile={setImage}
                        />
                }
            </Form.Group>
            <ConfirmModal
                show={showModal}
                onConfirm={() => {
                    if (fileToDelete){
                        deleteFile(fileToDelete.id)
                    }
                    setShowModal(false);
                }}
                onClose={() => setShowModal(false)}
                message="Файл будет удалён с сервера без возможности восстановления. Вы уверены?"
            />
        </Form>
    )
}

const styledLabel = {
    fontWeight: 600,
    color: '#7f7f7f'
}

const styledAlert = { fontSize: '14px', lineHeight: '20px', color: '#dc3545' }